let host2 = 'https://intclubb2b.liantuofu.com/fund';
// if (process.env.NODE_ENV == "development") {
//     host = 'https://prefund.yuemiaoai.com'
// }
// if(process.env.NODE_ENV == "production") {
//     host = 'https://prefund.yuemiaoai.com'
// }


export default host2;